import { runFetch } from './request';
import { IDistrict } from '@/types';

export async function getDistricts(): Promise<IDistrict[]> {
    const result = await runFetch('districts/', {method: 'GET'});

    return result;
}